export default __webpack_public_path__ + "static/media/wmatic-wei.7262d320.svg";